import React, { useState } from "react";
import { applyCoupon } from "../../utils/apis/payment";
import { useDispatch, useSelector } from "react-redux";
// import checkout_icon from "../../assets/icons/checkoutCom.svg";
import paypal_icon from "../../assets/icons/paypal_icon_blue.svg";
import { returnErrors } from "../../utils/store/reducers/Error";
import Spinner from "../../reusableComponents/spinner/Spinner";
import coinPaymentIcon from "../../assets/icons/coinpaymentsIcon.svg";
import "./Repayment.scss";
import { resetRebillPayments } from "../../utils/apis/userApi";
import { useLocation } from "react-router-dom";
import { setLastPayment } from "../../utils/store/reducers/accountMetricsSlice";
import nuvei from "../../assets/icons/nuveis.svg";

const RePayment = () => {
  const [couponCode, setCouponCode] = useState("");
  const [couponError, setCouponError] = useState("");
  const [load, setLoad] = useState(false);
  const [paymentInfo, setPaymentInfo] = useState({});
  const dispatch = useDispatch();
  const { idToken } = useSelector((state) => state.auth);

  const [isLoading, setIsLoading] = useState(false);
  const { state } = useLocation();
  const [payload, setPayload] = useState({
    payment_method: "nuvei", // "checkout" payment method commented out
    payment_type: "activation_fees",
    account_id: state?.account,
    contract_id: state?.id,
    promo: "",
  });
  const handlePayment = async () => {
    setIsLoading(true);

    try {
      const response = await resetRebillPayments(idToken, payload);

      if (response.status < 399) {
        dispatch(setLastPayment(response?.data?.data));
        window.location.replace(response?.data.url);
      } else {
        dispatch(returnErrors(response.data.detail, 400));
      }
    } catch (error) {
      dispatch(returnErrors(error.message, error.response?.status || 500));
    } finally {
      setIsLoading(false);
    }
  };
  const paymentMethods = [
    // {
    //   method: "Checkout",
    //   value: "checkout",
    //   icon: checkout_icon,
    // },
    {
      method: "Nuvei",
      value: "nuvei",
      icon: nuvei,
    },
    {
      method: "Coinpayments",
      value: "coinpayment",
      icon: coinPaymentIcon,
    },

  ];

  const handleApplyCode = async () => {
    if (!couponCode) {
      setCouponError("The coupon code should not be empty.");
      return;
    }
    try {
      setLoad(true);
      const res = await applyCoupon(state?.account, couponCode, idToken);
      setLoad(false);
      if (res) {
        setPayload((prev) => ({
          ...prev,
          promo: res.coupon_applied,
        }));
        setPaymentInfo(res);
      }
    } catch (error) {
      setLoad(false);
      setCouponCode("");
      setPayload((prev) => ({
        ...prev,
        promo: "",
      }));
      setPaymentInfo(null);
      dispatch(
        returnErrors(error.response?.data.detail, error.response?.status)
      );
    }
  };
  return (
    <div>
      <div className="repayment-modal-container">
        <div className="payment-container">
          <p>Payment Method</p>
          <div className="payment-methods">
            {paymentMethods.map((item, index) => (
              <div
                key={index}
                className="grayButton selected"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                <img src={item.icon} alt="" height="100%" />
                <p>{item.method}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="coupon_container">
          <div className="x">
            <div className="flexColumn">
              <p className="title">Challenge</p>
              <p className="challengeTitle">Reset Fee</p>
            </div>
            <div className="couponWrapper">
              <input
                placeholder="Coupon"
                type="text"
                value={couponCode}
                onChange={(e) => setCouponCode(e.target.value)}
                onBlur={() => setCouponError("")}
              />
              <button onClick={handleApplyCode}>
                {load ? (
                  <Spinner size={20} />
                ) : !paymentInfo?.discount ? (
                  "Apply code"
                ) : (
                  "Applied"
                )}
              </button>
            </div>
            {couponError && <p className="error">{couponError}</p>}
            <div className="flexSpacebetween discountSection">
              <p>Discount</p>
              <span>${paymentInfo?.discount || 0}</span>
            </div>
            <div className="flexSpacebetween priceSection">
              <span>Total Price</span>
              <span>${paymentInfo?.final_price || state?.purchase_price}</span>
            </div>
            <div className="flexCenter">
              <button
                className="standard-button width50"
                onClick={handlePayment}
                disabled={isLoading}
              >
                {isLoading ? <Spinner size={20} /> : "Make Payment"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RePayment;
